<template>
    <div id="OrderTypeSelect" class="order-type-select">        
        <b-form-select v-model="curDocType" :options="options" class="mb-3" v-bind:style="{'background-color': activeColor}">
        </b-form-select>        
    </div>
</template>

<script>

export default {
    name: 'OrderType',    
    data() {
        return {           
        options: [
                { value: 1, text: 'Venta' },
                { value: 5, text: 'Abono' },
                { value: 0, text: 'Presupuesto' },
                { value: 4, text: 'Cobro' },
                { value: 9, text: 'Historial' },                                  
            ],
        curDocType : this.$store.state.curDocType,
        activeColor : '#9EDE7D' //Color Rojo para los abonos
        }
    },    
    mounted: function () {
        
       if ( this.$store.state.curDocType == 5) this.activeColor = '#D67373'
            else this.activeColor = '#9EDE7D'
    },
    watch:{
     curDocType(newval,oldval){            
            if (newval == 5) this.activeColor = '#D67373'
            else this.activeColor = '#9EDE7D'
            if (this.$store.state.curOrder == ""){
                this.$store.commit('setcurDocType', newval)
            }else{     
              this.$nextTick(() => {this.curDocType=this.$store.state.curDocType})
            }
         }
       }


   
}
</script>
<style scoped>
.mb-3
{
    background-color : #d1d1d1; 
}
</style>